<template>
<div id="home">
<div class="carousel" >
  <el-carousel trigger="click" arrow="never" :autoplay="false" ref="cardShow">
    <el-image :src="require('../../assets/home/left.png')"
                @click.native="imageClick('left')"
                class="left-img"></el-image>
      <el-carousel-item v-for="(item,index) in images" :key="index">
         <img :src="images[index].url" style="width:100%;height:100%;">
      </el-carousel-item>
          <el-image :src="require('../../assets/home/right.png')"
                @click.native="imageClick('right')"
                class="right-img"></el-image>
        </el-carousel>

</div>
<div class="tags">
<div class="home-title">
        <span class="home-slogan">能源行业 信心之选</span>
        <span class="home-sloganen">CONFIDENCE IN THE ENERGY SECTOR</span>
</div>
<div class="tags-content">
  <span>能信科技是一家以信息化咨询、嵌入式开发、业务应用开发、大数据、云计算、移动应用、系统集成等信息技术服务行业客户的高科技企业</span>
</div>
</div>

<div class="body">
  <div class="fangan">
    <div class="eg">产品及方案</div>
    <div class="eg-en">Products And Solutions</div>
      <div class="fangan-content">
        <el-row :gutter="18" class="home-el-row">    
            <el-col :span="6"  :style="{background:'url('+fangan[0].url+')',backgroundSize:'100% 100%'}" class="home-el-col" @click.native="openPlan(1)">  </el-col>
            <el-col :span="6" :style="{background:'url('+fangan[1].url+')',backgroundSize:'100% 100%'}" style="margin-left:170px;" class="home-el-col" @click.native="openPlan(2)"></el-col>
             <el-col :span="6" :style="{background:'url('+fangan[2].url+')',backgroundSize:'100% 100%'}" style="margin-left:170px;" class="home-el-col" @click.native="openPlan(3)"></el-col>
          </el-row>
          <el-row :gutter="18" class="home-el-row">    
            <el-col :span="5"  class="el-col-jx" @click.native="openPlan(1)" > 
              <div class="fangan-name" style="padding:0px;" >低压拓扑传感器</div>
              <div class="fangan-ename" style="padding:0px;">LOW-VOLTAGE TOPOLOGY SENSOR</div>
               </el-col>
            <el-col :span="5" class="el-col-jx" style="margin-left:170px;" @click.native="openPlan(2)">
              <div class="fangan-name">充电桩扩容</div>
              <div class="fangan-ename">CHARGING PILE EXPANSION</DIV>
            </EL-COL>
             <el-col :span="5" class="el-col-jx" style="margin-left:170px;" @click.native="openPlan(3)">
               <div class="fangan-name">安全用电测控终端</div>
              <div class="fangan-ename">SAFE ELECTRICAL MEASUREMENT AND CONTROL TERMINAL</div>
             </el-col>
          </el-row>

    <el-row :gutter="12"  style="margin-top:40px" class="home-el-row">
            <el-col :span="6" :style="{background:'url('+fangan[3].url+')',backgroundSize:'100% 100%'}" class="home-el-col" @click.native="openPlan(4)"></el-col>
            <el-col :span="6" :style="{background:'url('+fangan[4].url+')',backgroundSize:'100% 100%'}" class="home-el-col" @click.native="openPlan(5)"></el-col>
          </el-row>
              <el-row :gutter="12" class="home-el-row">
            <el-col :span="5" class="el-col-jx" @click.native="openPlan(4)">
              <div class="fangan-name">智慧水电</div>
              <div class="fangan-ename">SMART HYDROPOWER</div>
            </el-col>
            <el-col :span="5" class="el-col-jx" @click.native="openPlan(5)">
              <div class="fangan-name">IT产品及服务</div>
              <div class="fangan-ename">IT PRODUCTS AND SERVICES</div>
            </el-col>
          </el-row>
          </div>
  </div>

  <div class="xinwen">
    <span class="eg">新闻中心</span>
     <div class="eg-en">News Center</div>
     <div style="float:right;margin-top:50px;">
  <el-button  class="zx"   :active="true" @click="getNewList(1)">公司资讯</el-button>
  <el-button  class="zx" @click="getNewList(2)">行业资讯</el-button>
     </div>
        <div id="news-left">
            <el-row  v-for ="newsafter in newsList.slice(0,1)" :key="newsafter.id" >
                <el-col :span="12">
                <el-image fit="fill" :src="imageUrl+newsafter.img" class="home-new-img"></el-image>
                </el-col>
                <el-col :span="12" class="home-new-text text-link" @click.native="openNews(newsafter.id)">
                <div class="home-new-f-title">{{newsafter.title.slice(0,20)}}</div>
                <div class="home-new-line"></div>
                <div class="home-new-f-summary">{{newsafter.summary.slice(0,40)}}</div>
                <div class="home-new-f-time">{{newsafter.creatDate.slice(0,10)}}</div>
                </el-col>
            </el-row>

            <el-row class="home-new-se text-link"  v-for ="newsmid in newsList.slice(1,3)" :key="newsmid.id"  @click.native="openNews(newsmid.id)" >
              <el-col :span="24">
                <div class="home-new-se-title">{{newsmid.title.slice(0,20)}}</div>
                <div class="home-new-se-summary">{{newsmid.summary.slice(0,90)}}</div>
                <div class="home-new-se-time">{{newsmid.creatDate.slice(0,10)}}</div>
              </el-col>
            </el-row>
        </div>
        <div id="news-right">
          <el-row :gutter="20" class="home-new-li text-link"  v-for ="newsbefor in newsList.slice(3,7)" :key="newsbefor.id" @click.native="openNews(newsbefor.id)">
          <el-col :span="2" >
              <div class="home-new-li-time">
                <div class="time-day">{{newsbefor.creatDate.slice(8,10)}}</div>
                <div class="time-ym">{{newsbefor.creatDate.slice(0,7)}}</div>
              </div>
              </el-col>
            <el-col :span="19" :offset="3" >
              <div class="home-new-li-title">{{newsbefor.title.slice(0,20)}}</div>
              <div class="home-new-li-summary">{{newsbefor.summary.slice(0,40)}}</div>
              </el-col>
          </el-row>
        </div>

  </div>
</div>
</div>
</template>

<script>
import { getRequest } from "../../util/api";
export default {
    data() {
    return {
      pushtype:'company',
      newsList:[
      ],
    imageUrl:'',

    images:[
         {url: require("../../assets/home/1.png")},
         {url: require("../../assets/home/2.png")},
         {url: require("../../assets/home/3.png")},
     ],
     fangan:[
       { url:require('../../assets/home/fangan1.png')},
        { url:require('../../assets/home/fangan2.png')},
         { url:require('../../assets/home/fangan3.png')},
          { url:require('../../assets/home/fangan4.png')},
           { url:require('../../assets/home/fangan5.png')}

     ]
    }
  },
    mounted() {
    this.getNewList(1)
  },
  methods: {
    openNews(contentId){
      window.scrollTo(0,0);
      let params = {
      id: this.pushtype,
      contentId:contentId
      }
      this.$router.push({ path: '/news', query: params })

      // // this.$router.push('/news?id='+this.pushtype+'&contentId='+id);
      console.log(this.$router.options)
    },
    openPlan(key){
      window.scrollTo(0,0);
      if(key==1){
        this.$router.push('/plan?id=low_voltage')
      }else if(key==2){
        this.$router.push('/plan?id=expansion')
      }else if(key==3){
        this.$router.push('/plan?id=terminal')
      }else if(key==4){
        this.$router.push('/plan?id=smart_hyd')
      }else{
        this.$router.push('/plan?id=it_server')
      }
        
    },
    imageClick (val) {
      if (val == 'right') {
      //点击右按钮切换至下一页走马灯
        this.$refs.cardShow.next()
      } else {
      //点击左按钮切换至上一页走马灯
        this.$refs.cardShow.prev()
      }
    },
    getNewList(key) {
      if(key==1){
        this.pushtype='company'
      }else{
        this.pushtype='industry'
      }
      let origin = document.location.origin
      let that = this
      that.imageUrl='http://www.lensyn.com:8088/';
      let params = {
        type: key,
        keyWords: that.keyWords,
        pageStart: 0,
        pageSize: 10
      }
      getRequest('/news/list', params).then(function(res) {
        if (res.data.meta.code === 1) {
          that.newsList = res.data.data;
        }
      })
    },
  }
}
</script>

<style >
.home-new-li-summary{
  margin-top: 10px;
  height: 65px;
   font-weight: 400;
  font-size:14px;
  line-height: 20px;
  color: #828282;
}

.home-new-li-title{
  height: 30px;
   font-weight: 500;
  font-size:16px;
  line-height: 20px;
  color: #000;
   border-bottom: 2px solid #E0E0E0;
}
.time-ym{
  font-weight: 400;
  font-size:14px;
  line-height: 20px;
  color: #828282;
}

.time-day{
    font-weight: 500;
  font-size:32px;
  line-height: 48px;
  color: #000;
}
.home-new-li-time{
  border-right: 2px solid #E0E0E0;
  height: 75px;
  width: 75px;
  text-align: center;
}
.home-new-li{
  height: 90px;
  margin: 0px 0px 60px 0px !important;
}
.home-new-se-time{
  font-weight: 400;
  font-size:14px;
  line-height: 20px;
  color: #828282;
}
.home-new-se-summary{
  margin: 15px 0px;
  font-weight: 400;
  font-size:14px;
  line-height: 20px;
  color: #828282;
}
.home-new-se-title{
  font-weight: 500;
  font-size:16px;
  line-height: 20px;
  color: #0E2336;
}
.home-new-se{
  height: 110px;
  margin-top: 30px;
}
.home-new-f-time{
  color: #FFFFFF;
  font-weight: 400;
  font-size:14px;
  line-height: 20px;
  padding: 0px 20px 0px 35px;
}
.home-new-f-summary{
  color: #FFFFFF;
  font-weight: 400;
  font-size:14px;
  line-height: 20px;
  padding: 0px 20px 20px 35px;
}
.home-new-line{
  width:60px;
  border-top: 1px solid #FFFFFF;
  margin: 15px 0px 20px 35px;
}
.home-new-f-title{
  color: #FFFFFF;
  font-weight: 500;
  font-size:16px;
  line-height: 20px;
  padding: 35px 20px 0px 35px;
}
.home-new-img{
     border-radius: 4px 0px 0px 4px;
    height: 230px;
}
.home-new-text{
    border-radius: 0px 4px 4px 0px;
    height: 230px;
    background: #10263F;
}

.zx{
   background-color:#10263F;
  color: #FFFFFF;
  
}
.zx:active{
  background-color:#3199E9;
  color: #FFFFFF;
}
.zx:focus{
   background-color:#3199E9;
  color: #FFFFFF;
}

#news-right{
  position: absolute;
  width: 33%;
  height: 540px;
  left:55.5%;
  margin-top: 130px;
}

#news-left{
  position: absolute;
  width: 45%;
  height: 540px;
  margin-top: 130px;
}

.fangan-name{
font-weight: 500;
font-size: 24px;
line-height: 36px;
text-align: center;
color: #0E2336;
}

.fangan-ename{
  font-weight: 500;
  font-size: 12px;
line-height: 21px;
text-align: center;
color: #4F4F4F;
}
.el-col-jx{
  border-radius: 0% !important;
  width: 250px !important;
  height: 90px !important;
  border: 0px solid transparent !important;
  padding:0px !important;
  cursor:pointer;
}


.home-el-row {
  display: flex;
  justify-content: space-between;
  width: 100% !important;
}

.home-el-col {
  border-radius: 100%;
  width: 196px !important;
  margin-top: 40px;
  height: 196px;
  border: 4px solid #D6EBFB;
  cursor:pointer;
}

.body{
  width: 100%;
}
.fangan{
   margin: auto;
  margin-top: 40px;
  width: 80%;
  height:880px;
  border-bottom: 4px solid  #E4ECF3!important;
}
.fangan-content{
  position: absolute;
   margin-top: 80px;
   width: 80%;
}
.eg{
  font-size:36px;
  line-height: 54px;
  font-weight: 500;
   position: absolute;
}
.eg:after{
    content:'';
    position: absolute;
    width: 150px;
    height: 4px;
    top: 53%;
    background-color: #000;
    margin-left: 10px;
        }
.eg-en{
   position: absolute;
  font-size:24px;
  line-height: 36px;
  margin-top: 50px;

}
.xinwen{
  margin: auto;
  margin-top: 35px;
  margin-bottom:85px; 
  width: 80%;
  height:680px;
}
.tags{
  position: absolute;
  top: 150px;
  left: 10%;
  width: 570px;
  z-index: 3;
}
.el-carousel--horizontal {
    overflow-x: hidden;
    height: 460px;
}
.home-title {
  width: 100%;
  color: rgba(255, 255, 255, 1);
}
.home-slogan{
  font-size: 64px;
}

.home-sloganen{
  font-size: 20px;
}

.tags-content{
  margin-top: 20px;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  line-height: 40px;
}
.el-carousel__indicators--horizontal {
    display: none !important;
}
.text-link{
    cursor:pointer;
}
.carousel{
  height: 460px;
  width: 100%
}
.left-img{
z-index:4;
position: relative;
display: inline-block;
overflow: hidden;
margin-top: 366px;
margin-left: 62.2%;
  cursor:pointer;
}
.right-img{
z-index: 4;
position: relative;
display: inline-block;
overflow: hidden;
height: 90px;
  cursor:pointer;
}



#home{
  width:99%;
}


.el-carousel__container {
    position: relative;
    height: 460px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/content/Home.vue